function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAktier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.90217 24.374C6.72868 24.374 6.5622 24.4429 6.43951 24.5656C6.31671 24.6883 6.2478 24.8548 6.2478 25.0284V29.9639C6.2478 30.1977 6.37252 30.4137 6.57498 30.5305C6.77745 30.6475 7.02688 30.6475 7.22935 30.5305C7.43181 30.4137 7.55653 30.1977 7.55653 29.9639V25.0284C7.55653 24.8548 7.48762 24.6883 7.36493 24.5656C7.24213 24.4429 7.0758 24.374 6.90217 24.374Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1514 21.9767C9.97784 21.9767 9.81147 22.0456 9.68867 22.1684C9.56598 22.2911 9.49707 22.4575 9.49707 22.6311V29.9635C9.49707 30.1973 9.62179 30.4132 9.82425 30.5301C10.0267 30.647 10.2761 30.647 10.4786 30.5301C10.6811 30.4132 10.8058 30.1972 10.8058 29.9635V22.6311C10.8058 22.4575 10.7369 22.2911 10.6141 22.1684C10.4914 22.0456 10.325 21.9767 10.1514 21.9767Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4001 19.6777C13.2265 19.6777 13.0601 19.7466 12.9373 19.8694C12.8146 19.9921 12.7457 20.1586 12.7457 20.3321V29.9638C12.7457 30.1976 12.8704 30.4136 13.0729 30.5304C13.2754 30.6473 13.5248 30.6473 13.7273 30.5304C13.9297 30.4136 14.0545 30.1976 14.0545 29.9638V20.3321C14.0545 20.1586 13.9855 19.9921 13.8627 19.8694C13.7401 19.7466 13.5736 19.6777 13.4001 19.6777Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6494 16.9312C16.4759 16.9312 16.3094 17.0001 16.1867 17.1229C16.0639 17.2456 15.995 17.4121 15.995 17.5856V29.964C15.995 30.1978 16.1197 30.4137 16.3222 30.5306C16.5246 30.6475 16.7741 30.6475 16.9765 30.5306C17.179 30.4137 17.3037 30.1977 17.3037 29.964V17.5856C17.3037 17.4121 17.2348 17.2456 17.1121 17.1229C16.9893 17.0001 16.823 16.9312 16.6494 16.9312Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8986 20.3071C19.725 20.3071 19.5587 20.376 19.4359 20.4988C19.3132 20.6215 19.2443 20.788 19.2443 20.9615V29.9636C19.2443 30.1974 19.369 30.4134 19.5714 30.5302C19.7739 30.6472 20.0233 30.6472 20.2258 30.5302C20.4283 30.4134 20.553 30.1974 20.553 29.9636V20.9615C20.553 20.788 20.4841 20.6215 20.3613 20.4988C20.2386 20.376 20.0722 20.3071 19.8986 20.3071Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3967 16.1866C26.2232 16.1866 26.0567 16.2555 25.934 16.3782C25.8112 16.5009 25.7423 16.6673 25.7423 16.841V29.964C25.7423 30.1977 25.867 30.4137 26.0695 30.5306C26.272 30.6475 26.5214 30.6475 26.7239 30.5306C26.9263 30.4137 27.051 30.1977 27.051 29.964V16.841C27.051 16.6674 26.9821 16.5009 26.8593 16.3782C26.7366 16.2555 26.5702 16.1866 26.3967 16.1866Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1469 18.6539C22.9733 18.6539 22.807 18.7228 22.6842 18.8456C22.5615 18.9683 22.4926 19.1347 22.4926 19.3083V29.9644C22.4926 30.1981 22.6173 30.4141 22.8197 30.5309C23.0222 30.6479 23.2716 30.6479 23.4741 30.5309C23.6766 30.4141 23.8013 30.1981 23.8013 29.9644V19.3083C23.8013 19.1347 23.7324 18.9683 23.6096 18.8456C23.4869 18.7228 23.3204 18.6539 23.1469 18.6539Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.645 13.6506C29.4715 13.6506 29.305 13.7196 29.1823 13.8423C29.0595 13.965 28.9906 14.1315 28.9906 14.305V29.9639C28.9906 30.1977 29.1153 30.4138 29.3178 30.5306C29.5202 30.6476 29.7697 30.6476 29.9721 30.5306C30.1746 30.4138 30.2993 30.1977 30.2993 29.9639V14.305C30.2993 14.1315 30.2304 13.965 30.1077 13.8423C29.9849 13.7196 29.8186 13.6506 29.645 13.6506Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8523 5.24078C31.7183 5.0757 31.5123 4.98645 31.3002 5.00168L27.3716 5.27561V5.27572C27.1407 5.29489 26.9371 5.43473 26.8365 5.64336C26.7358 5.852 26.7529 6.09836 26.8815 6.29102C27.0101 6.48379 27.231 6.59412 27.4623 6.58115L29.3093 6.45227L20.0356 13.3024L17.513 10.565V10.5651C17.4034 10.4463 17.2539 10.3722 17.093 10.3572C16.9322 10.342 16.7714 10.387 16.6417 10.4833L6.26432 18.1884V18.1883C6.07655 18.3277 5.97749 18.5567 6.00434 18.7889C6.03118 19.0212 6.17986 19.2215 6.39448 19.3144C6.60898 19.4072 6.85681 19.3786 7.04459 19.2392L16.9495 11.8846L19.4713 14.621C19.5806 14.7396 19.7298 14.8138 19.8904 14.829C20.051 14.8443 20.2115 14.7998 20.3412 14.704L30.1692 7.4446L29.8015 8.76835C29.7524 8.93641 29.7726 9.11715 29.8577 9.27008C29.9428 9.42313 30.0856 9.5356 30.2542 9.58246C30.4229 9.62943 30.6034 9.60674 30.7552 9.51962C30.907 9.4325 31.0176 9.28819 31.0623 9.11885L31.9761 5.82985C32.033 5.62504 31.9869 5.40544 31.8524 5.24087L31.8523 5.24078Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAktier);
export default __webpack_public_path__ + "static/media/aktier.e592bdb34d825db6a9dbbdf38f8f5300.svg";
export { ForwardRef as ReactComponent };